module.exports = __webpack_public_path__ + "img/emoji_ok.b72ed632.png";